<template>
  <div id="footer" class="container-fluid">
    <div class="company-info">
      <div class="company-item">
        <img src="@/assets/img/company1.png" alt="" class="company-img">
        <div class="company-label">29K+</div>
      </div>
      <div class="company-item">
        <img src="@/assets/img/company2.png" alt=""  class="company-img">
        <div class="company-label">8K+</div>
      </div>
      <div class="company-item">
        <img src="@/assets/img/company3.png" alt=""  class="company-img">
        <div class="company-label">28K+</div>
      </div>
    </div>
    <p class="title">上海动木灵网络科技有限公司</p>
    <div class="info-list">
      <div class="info-item">
        <img src="@/assets/img/bottom_location.png" alt="" class="info-list-img">
        <div class="info-list-label">上海市闵行区中春路</div>
      </div>
      <div class="info-item">
        <img src="@/assets/img/bottom_email.png" alt=""  class="info-list-img">
        <div class="info-list-label">ljfdbxj@163.com</div>
      </div>
      <div class="info-item">
        <img src="@/assets/img/bottom_qq.png" alt=""  class="info-list-img">
        <div class="info-list-label">2603307116</div>
      </div>
    </div>
    <div class="bottom">
      <p class="copy" @click="handleGov">沪ICP备2021009752号-1 </p>
    </div>
   
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    handleGov() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 788px;
  color: #fff;
  background: linear-gradient(180deg, #FFEFF5 0%, #FFC4BA 100%);
  text-align: center;
  padding-top: 2rem;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 30px;
  font-weight: 600;
  color: #FF6C6C;
  line-height: 84px;
  transform: translateY(-200px);
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  font-size: 16px;
  font-weight: 400;
  color: #4E1A1A;
  line-height: 20px;
}
.company-info{
  display: flex;
  justify-content:center;
  margin-bottom: 50px;
  align-items: center;
  transform: translateY(-200px);
  z-index: 200;
}
.bottom{
  transform: translateY(-100px);
}
.company-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;
  position: relative;
}
.company-img{
  width: 334px;
  height: 473px;
}
.company-label{
  font-size: 58px;
  font-weight: bold;
  color: #4E1A1A;
  line-height: 77px;
  position: absolute;
  top: 80px;
}
.info-list{
  display: flex;
  justify-content:center;
  margin-bottom: 50px;
  align-items: center;
  transform: translateY(-200px);
}
.info-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;
}
.info-list-img{
  width: 60px;
  height: 60px;
}
.info-list-label{
  font-size: 20px;
  font-weight: 400;
  color: #FF4747;
  line-height: 28px;
  margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue